import * as React from 'react';
import {
  MasonryEngineNode,
  MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import {
  Box,
  GDSColorToken,
  colorTokenMap,
  GDSBorderRadii,
} from '@leagueplatform/genesis-core';
import { radiusTokenMap } from '../../../utils/radius-token-map';

export const NODE_TYPE_PLAN_SPENDING_CONTAINER = 'planSpendingContainer';

type GDSBorderRadiiKeys = keyof GDSBorderRadii;

type PlanSpendingContainerProps = {
  backgroundColor?: GDSColorToken;
  borderRadius?: GDSBorderRadiiKeys;
};

type PlanSpendingContainerNode = MasonryEngineNode<
  typeof NODE_TYPE_PLAN_SPENDING_CONTAINER,
  PlanSpendingContainerProps,
  {},
  {
    items: MasonryEngineNode<string, any>[];
  }
>;

export type PlanSpendingContainerRendererProps =
  MasonryEngineNodeRendererProps<PlanSpendingContainerNode>;

export function PlanSpendingContainerRenderer({
  backgroundColor: colorToken = 'surfaceBackgroundSecondary',
  borderRadius: radius = 'card',
  items,
}: PlanSpendingContainerRendererProps) {
  if (!items || !items.length) return null;
  const backgroundColor = colorTokenMap[colorToken] ?? colorToken;
  const borderRadius = radiusTokenMap[radius] ?? radius;

  return (
    <Box
      css={{
        backgroundColor,
        borderRadius,
        padding: '$two',
      }}
    >
      {items}
    </Box>
  );
}
